import * as xlsx from "xlsx";
import type { AOA2SheetOpts } from "xlsx"

//ExcelFile
type ExcelSheet = ReturnType<typeof xlsx.utils.aoa_to_sheet>
type Excel = ReturnType<typeof xlsx.utils.book_new>
//Ref
type Row = Col[];
type Col = any;
type Sheet = Row[];
type ColWidth = { wch: number }[];
type NewSheetOption = {
    colWidth?: ColWidth,
    sheetOpts?: AOA2SheetOpts
}
//
type ExcelSheetInfos = {
    excelSheet: ExcelSheet,
    name?: string
}

export default class ExcelWriter {


    public static NewExcel() {
        return xlsx.utils.book_new();
    }

    public static NewSheet(sheet: Sheet, colHeader?: Row, option?: NewSheetOption) {
        const __sheet = colHeader
            ? [colHeader, ...sheet]
            : [...sheet]
        const newSheet = xlsx.utils.aoa_to_sheet(__sheet, option?.sheetOpts)

        if (option?.colWidth) {
            newSheet["!cols"] = option.colWidth
        }
        return newSheet;
    }

    public static ConcatSheetToExcel(excel: Excel, sheetInfos: ExcelSheetInfos[]) {
        for (const sheetInfo of sheetInfos) {
            xlsx.utils.book_append_sheet(excel, sheetInfo.excelSheet, sheetInfo.name || "")
        }

        return excel
    }

    public static writeExcel(excel: Excel, fileName: string) {
        xlsx.writeFile(excel, fileName)
    }

}